import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { FlashJustDragged } from '../moveCard/flashJustDragged';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetReleaseManagementIsOpen extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetReleaseManagementIsOpen';

    public constructor(public isOpen: boolean) {
        super(SetReleaseManagementIsOpen.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetReleaseManagementIsOpen): Promise<boolean> => {
    if (!action.isOpen) {
        dispatch(new FlashJustDragged());
    }

    return true;
};

const reducer = (state: StorymapState, action: SetReleaseManagementIsOpen): void => {
    state.isReleaseManagementOpen = action.isOpen;
};

//@ts-ignore
registerMiddleware(SetReleaseManagementIsOpen.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetReleaseManagementIsOpen.ACTION_TYPE, reducer);
